import classNames from 'classnames/bind';
import { MouseEvent, ReactNode } from 'react';

import { Close } from '../../assets/icons/Icons';
import styles from './notificationAlert.module.scss';

const cx = classNames.bind(styles);

interface Props {
  /**
   * Icon or img to appear on the notification
   */
  icon: ReactNode;
  /**
   * Main text to appear in the notification
   */
  text: string;
  /**
   * Sub text to appear below the text
   */
  subText?: string;
  /**
   * Function to be called upon pressing the x button on the notification. if left null, the close button will not appear
   */
  onDismiss?: (e: MouseEvent<HTMLButtonElement>) => void;
  /**
   * Link to travel to when the notification is clicked
   */
  link?: string;
}

interface conditionalProps {
  link?: string;
  children?: ReactNode;
}

/* A helper component to apply link styling to notifications that have a link target */
const ConditionalLink = ({ link, children }: conditionalProps) =>
  link ? (
    <div className={cx('notification-container')}>
      <div className={cx('notification-link')}>
        <a href={link}>{children}</a>
      </div>
    </div>
  ) : (
    <div className={cx('notification-container')}>{children}</div>
  );

const NotificationAlert = ({ icon, text, subText, onDismiss, link, ...otherProps }: Props) => {
  return (
    <ConditionalLink link={link}>
      <div className={cx('notification')} {...otherProps}>
        <div className={cx('icon')}>{icon}</div>
        <div className={cx('content')}>
          <div className={cx('message')}>{text}</div>
          <div className={cx('subtext')}>{subText}</div>
        </div>
        {onDismiss ? (
          <button aria-label='dismiss notification' className={cx('close')} onClick={onDismiss}>
            {Close}
          </button>
        ) : null}
      </div>
    </ConditionalLink>
  );
};

export default NotificationAlert;
